import Link from 'next/link';
import ContentfulImage from '@/components/contentful-image';
import RichText from '../rich-text';

const VirtualShowRoom = ({ data }: any) => {
  const { shortDescription, linkUrl, title, cardImage, icon } = data;
  return (
    <div className="VirtualShowRoom">
      {cardImage?.url && (
        <div className="relative w-full h-[300px] min-[1024px]:h-[220px]">
          <ContentfulImage
            src={cardImage?.url}
            alt={cardImage?.title}
            className="object-cover"
            fill
            sizes="99.99vw"
          />
        </div>
      )}

      <Link
        rel="noopener noreferrer"
        target="_blank"
        className="flex flex-col hover:text-[#000]"
        href={`${linkUrl}`}
      >
        {icon?.url && (
          <ContentfulImage
            className={`${cardImage?.url ? 'mr-0 mt-3' : 'mr-3'}`}
            src={icon?.url}
            width={icon?.width}
            height={icon?.height}
            alt={icon?.title}
          />
        )}
        <div className="uppercase font-bold mt-3">{title}</div>
        <div className="">
          {shortDescription && <RichText data={shortDescription} />}
        </div>
      </Link>
    </div>
  );
};

export default VirtualShowRoom;
